/**
 * Route definition for /connect-wallet
 * Renders the ConnectWalletContainer component.
 *
 * @module routes/connect-wallet
 * @category Routes
 */
import { createFileRoute } from '@tanstack/react-router'
import ConnectWalletContainer from '@/containers/ConnectWallet'

export const Route = createFileRoute('/$locale/connect-wallet')({
  component: ConnectWallet,
})

/**
 * Connect wallet page component.
 * Renders the ConnectWallet container for wallet connection functionality.
 *
 * @returns {React.ReactElement}
 */
function ConnectWallet() {
  return (
    <ConnectWalletContainer />
  )
}